import React from 'react';
import Header from './Header'
import Form from './Form'
import FormFinal from './FormFinal'
import Counter from './Counter'
import { connect } from 'react-redux'

import './css/App.css'

const App = ({app: { step, form }}) => (
  <section className={`AppWrapper app_step${step}`}>
    <img src="./img/logo.svg" className={'logo'} alt=""/>
    <div className={`App`}>
      <section className="root_step_0">
        <Header step={Math.min(step, 4)}/>
        <section className="sub_steps">
          <section className="step_0">
            <Form form={form} step={0}/>
          </section>
          <section className="step_1">
            <Counter step={1} />
          </section>  
          <section className="step_2">
            <Counter step={2} />
          </section>
          <section className="step_3">
            <Counter step={3} />
          </section>  
          <section className="step_4">
            <Counter step={4} />
            <FormFinal />
          </section>
        </section>
      </section>
      <section className="root_step_1">
        <Header step={5}/>
      </section>
      <section className="root_step_2">
      </section>
      <section className="root_step_3">
      </section>
    </div>
  </section>
)

// <Header step={step}/>
// { step === 0 && <Form form={form} /> }
// { step > 0 && step < 5 && <Counter step={step} /> }
// { step === 4 && <FormFinal /> }

const mapStateToProps = ({ app }) => ({
  app
})

export default connect(
  mapStateToProps
)(App)


// WEBPACK FOOTER //
// ./src/containers/App.js